function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Error");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "1.-Start-using-the-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Login---error-message",
  transform: "translate(-282.000000, -502.000000)",
  fill: "#F0B000"
}, React.createElement("g", {
  id: "Icons/Error",
  transform: "translate(282.000000, 501.000000)"
}, React.createElement("g", {
  id: "error-icon",
  transform: "translate(0.916667, 1.833333)"
}, React.createElement("path", {
  d: "M19.6052314,15.4290479 L11.4585257,0.926275026 C11.1375669,0.354936764 10.5520906,0 9.93053839,0 C9.30898619,0 8.72350985,0.354936764 8.40251225,0.926316666 L0.255845409,15.4290479 C-0.0758585725,16.019582 -0.0856727588,16.7594361 0.230204392,17.3598805 C0.546159126,17.9603249 1.14144965,18.3333333 1.78383276,18.3333333 L18.077244,18.3333333 C18.7196271,18.3333333 19.3149564,17.9603249 19.6309112,17.3598389 C19.9467883,16.7593528 19.9369741,16.0194987 19.6052314,15.4290479 Z M18.5049563,16.6773226 C18.4179864,16.8425906 18.2540933,16.9453157 18.077244,16.9453157 L1.78383276,16.9453157 C1.60698345,16.9453157 1.44309041,16.8426322 1.35615922,16.6773643 C1.26918924,16.5120547 1.27190463,16.3083533 1.36318044,16.1458336 L9.50992486,1.64306074 C9.59829133,1.48578761 9.75946898,1.38805925 9.93057718,1.38805925 C10.1016466,1.38805925 10.2628242,1.48578761 10.3511907,1.64306074 L18.4978576,16.1458336 C18.5892109,16.3083949 18.5919263,16.5120547 18.5049563,16.6773226 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M9.93637926,5.88477366 C9.45842068,5.88477366 9.08540189,6.16572131 9.08540189,6.66377988 C9.08540189,8.18339119 9.24857876,10.3670531 9.24857876,11.8867057 C9.24861646,12.2825677 9.56339817,12.4485597 9.93641696,12.4485597 C10.216181,12.4485597 10.6125323,12.2825677 10.6125323,11.8867057 C10.6125323,10.3670944 10.7757092,8.18343248 10.7757092,6.66377988 C10.7757092,6.1657626 10.391043,5.88477366 9.93637926,5.88477366 Z",
  id: "Path",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M10.0424086,13.127572 C9.49558782,13.127572 9.08540189,13.5905117 9.08540189,14.1460905 C9.08540189,14.6884108 9.49554763,15.1646091 10.0424086,15.1646091 C10.5519763,15.1646091 10.9869976,14.6884108 10.9869976,14.1460905 C10.9869976,13.5905117 10.5519361,13.127572 10.0424086,13.127572 Z",
  id: "Path",
  fillRule: "nonzero"
})))));

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.21c66420.svg";
export { ForwardRef as ReactComponent };